import MUITooltip, { TooltipProps as MUITooltipProps } from '@mui/material/Tooltip';

import Zoom from '@mui/material/Zoom';

import { ReactElement } from 'react';

export type TooltipProps = MUITooltipProps;

export default function Tooltip({ title, children, ...props }: TooltipProps): ReactElement {
  return (
    <MUITooltip
      title={title}
      placement="top"
      enterDelay={750}
      enterNextDelay={750}
      // TransitionComponent={Zoom}
      arrow
      disableInteractive
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </MUITooltip>
  );
}
